<script>
  import { Footer, Text, Link, Divider, Logo } from "@getprovi/craft-svelte";
</script>

<Footer>
  <Logo class="w-56" />
  <Text size="sm" semibold>&copy; {new Date().getFullYear()} Tiz, Inc.</Text>
  <div class="flex flex-wrap items-center gap-12">
    <Link href="/privacy" size="sm" target="_blank" variant="secondary" semibold
      >Privacy Policy</Link
    >
    <Divider variant="vertical" />
    <Link href="/terms" size="sm" target="_blank" variant="secondary" semibold
      >Terms & Conditions</Link
    >
    <Divider variant="vertical" />
    <Link href="/terms/ads" size="sm" target="_blank" variant="secondary" semibold
      >Ad Terms & Conditions</Link
    >
    <Divider variant="vertical" />
    <Link
      href="https://www.provi.com/privacy/opt-out"
      size="sm"
      target="_blank"
      variant="secondary"
      semibold
    >
      Do Not Sell My Information
    </Link>
  </div>
  <slot />
</Footer>
